import { Component } from "react";
import { compose } from "redux";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import PropTypes from "prop-types";
import ClaimsWrapper from "../../../../shared/ui/Claim.Wrapper";

import Link from "admin/shared/ui/Link.Component";

import { organisationConnector } from "../../../../services/users/organisations/connector";
import { allClaimsOtherThanAml } from "../../../../shared/ClaimLists/Claim.Aml.All.List";
import { countries } from "../../../../shared/dictionary/enums";
import { MenuItem } from "@material-ui/core";

class OrganisationsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orgNo: "",
      orgName: "",
      address: "",
      postalCode: "",
      city: "",
      country: "SE",
      clicked: false,
    };
  }
  /////////////////
  //// Organisation actions
  addCompany = () => {
    this.setState({ clicked: true });

    if (!this.validationText())
      this.props.addCompany(
        this.state.orgNo,
        this.state.name,
        this.state.address,
        this.state.postalCode,
        this.state.city,
        this.state.country,
        this.props.personId,
      );
  };

  validationText = () => {
    // for now need to add validation
    let validationText = "";

    if (!this.state.name) validationText = "Company Name missing";

    if (!this.state.orgNo) validationText = "Organisation Number missing";

    if (!this.state.address) validationText = "Address missing";

    if (!this.state.postalCode) validationText = "Postal Code missing";

    if (!this.state.city) validationText = "City missing";

    if (!this.state.country) validationText = "Country missing";

    return validationText;
  };

  ////////////////
  //// Company form

  handleChangeOrgNo = (event) => {
    this.setState({
      orgNo: event.target.value,
    });
  };

  handleChangeName = (event) => {
    this.setState({
      name: event.target.value,
    });
  };

  handleChangeAddress = (event) => {
    this.setState({
      address: event.target.value,
    });
  };

  handleChangePostalCode = (event) => {
    this.setState({
      postalCode: event.target.value,
    });
  };

  handleChangeCity = (event) => {
    this.setState({
      city: event.target.value,
    });
  };

  handleChangeCountry = (event) => {
    this.setState({
      country: event.target.value,
    });
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-6">
            <h4>Add new company</h4>
            <div>
              <div
                style={{
                  float: "left",
                  maxWidth: "300px",
                  paddingRight: "30px",
                }}
              >
                <TextField
                  size="small"
                  variant="outlined"
                  value={this.state.orgNo}
                  onChange={this.handleChangeOrgNo}
                  label="Organisation number"
                />
              </div>
              <TextField
                size="small"
                variant="outlined"
                value={this.state.name}
                onChange={this.handleChangeName}
                label="Company name"
              />
            </div>
            <div>
              <div
                style={{
                  float: "left",
                  maxWidth: "600px",
                  paddingRight: "30px",
                }}
              >
                <TextField
                  size="small"
                  variant="outlined"
                  value={this.state.address}
                  onChange={this.handleChangeAddress}
                  label="Address"
                />
              </div>
              <TextField
                size="small"
                variant="outlined"
                value={this.state.postalCode}
                onChange={this.handleChangePostalCode}
                label="Postal Code"
              />
            </div>
            <div>
              <div
                style={{
                  float: "left",
                  maxWidth: "300px",
                  paddingRight: "30px",
                }}
              >
                <TextField
                  size="small"
                  variant="outlined"
                  value={this.state.city}
                  onChange={this.handleChangeCity}
                  label="City"
                />
              </div>
              <TextField
                label="Country"
                size="small"
                variant="outlined"
                select
                id="ProfilesPerDomain"
                value={this.state.country}
                onChange={this.handleChangeCountry}
              >
                {Object.keys(countries).map((country) => (
                  <MenuItem key={country} value={country}>
                    {countries[country]}{" "}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
              <Button
                variant="contained"
                color="primary"
                onClick={this.addCompany}
              >
                Add Company
              </Button>
            </ClaimsWrapper>
            <p style={{ color: "red" }}>
              <b>{this.state.clicked && this.validationText()}</b>
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h4>Existing organisations</h4>
            {Object.keys(this.props.organisationsData).map((item, index) => {
              return (
                <div key={index}>
                  Organisation name: {this.props.organisationsData[item]} <br />
                  Identity:{" "}
                  <Link toState={"userOverview"} parameters={["query", item]}>
                    {item}
                  </Link>{" "}
                  <hr />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    addCompany: PropTypes.func,
    organisationsData: PropTypes.any,
    personId: PropTypes.any,
  };
}

export const Organisations = compose(organisationConnector)(
  OrganisationsComponent,
);
